import axios from 'axios';
import { useEffect, useState } from 'react';
import makeAnimated from 'react-select/animated';
import AsyncSelect from 'react-select/async';

const SearchUserDropdown = ({ setGroupMembers, modalInfo }) => {
    const [query, setQuery] = useState('')
    const [selectedOption, setSelectedOption] = useState('')
    
    //get animated components wrapper
    const animatedComponents = makeAnimated();
    
    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (modalInfo) {
            const [userIDList, userNameList] = [
                modalInfo.userIDList.split(','),
                modalInfo.userNameList.split(',')
            ];

            const merger = userIDList.map((node, index) => ({
                empId: node,
                formalName: `${userNameList[index]}`
            }));
            setSelectedOption(merger)
            setGroupMembers(merger)
        }
    }, [modalInfo, setGroupMembers]);

    // const loadOptions = async () => {
    //     // You must return this otherwise react-select won't know when the promise resolves! 
    //     const res = await fetch(`https://tgappdevs.topglove.com/TGHRCAWebService2/HRCAWebService.asmx/hrca_search_user?value=${query}`);
    //     const data = await res.json();
    //     const results = data.Result;

    //     if (results === 'No result found.') {
    //         return [];
    //     } else {
    //         return results;
    //     }
    // };

    const loadOptions = async () => {
        // You must return this otherwise react-select won't know when the promise resolves! 
        const url = REACT_APP_API_BACKEND_URL + '/api/searchpermissionuser'
        const queryDetails = {
            value: query
        }
        const res = await axios.post(url, queryDetails)
        const data = await res.data;
        const results = data.Result;

        if (results === 'No result found.') {
            return [];
        } else {
            return results;
        }
    };

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        setGroupMembers(selectedOption)
    };

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            isMulti
            components={animatedComponents}
            getOptionLabel={(e) => e.formalName}
            getOptionValue={(e) => e.empId}
            loadOptions={loadOptions}
            value={selectedOption}
            onInputChange={(value) => setQuery(value)}
            onChange={handleChange}
        />
    );
};

export default SearchUserDropdown;
